import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Dashboard.css";
import { LayoutDashboard } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const Dashboard = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [loginData, setLoginData] = useState([]);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const response = await axios.get("https://shubhjiwan.co.in/ShubhJiwan_backend11/dashboard.php");
        setTotalUsers(response.data.totalUsers);
        setLoginData(response.data.loginTrends);
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchDashboardStats();
  }, []);

  return (
    <div className="dashboard">
        <h2 className="dashboard-title flex items-center gap-2">
            <LayoutDashboard className="w-6 h-6" /> Dashboard
        </h2>


      {/* Total Users */}
      <div className="dashboard-container">
        <div className="stat-box total">
        <h3 style={{ color: "white" }}>Total Users</h3>
          <p>{totalUsers}</p>
        </div>
     

      {/* Login Trends Graph */}
      <div className="graph-container">
        <h3 className="graph-title">Login Trends</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={loginData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="logins" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
     </div>
  );
};

export default Dashboard;
